import { createFileRoute } from '@tanstack/react-router';
import { ShopPage } from '@/page/ShopPage';

export const Route = createFileRoute('/_app/shop')({ component: ShopPage });
